import React, { useState } from "react";
import { QuestionAndAnswer } from "../ProductDetailPageResult";

interface ExpandedDescriptionQuestionsAndAnswersProps {
  questionsAndAnswers: QuestionAndAnswer[];
}

const ExpandedDescriptionQuestionsAndAnswers = ({
  questionsAndAnswers,
}: ExpandedDescriptionQuestionsAndAnswersProps) => {
  const [activeIdList, setActiveIdList] = useState<string[]>(["customer-qa0"]);

  const addToActiveIdList = (id: string) => {
    const updatedList = activeIdList.concat(id);
    setActiveIdList(updatedList);
  };

  const removeFromActiveIdList = (id: string) => {
    const updatedList = activeIdList.filter((x) => x !== id);
    setActiveIdList(updatedList);
  };

  const isItemInActiveIdList = (id: string): boolean => {
    return !!activeIdList.find((x) => x === id);
  };

  const handleClick = (id: string) => {
    if (questionsAndAnswers?.length === 1) {
      return;
    }
    if (isItemInActiveIdList(id)) {
      removeFromActiveIdList(id);
    } else {
      addToActiveIdList(id);
    }
  };

  function getActiveClass(index: number) {
    const className = isItemInActiveIdList(`customer-qa${index}`)
      ? " qa-open"
      : "";

    return `${className} bg-white p-0`;
  }

  const questionClasses = () => {
    let className =
      "text-base icon-color-gray-800 py-[18px] pl-[18px] pr-10 outline-offset-[-11px]";

    if (questionsAndAnswers.length === 1) {
      className += " single-question";
    } else {
      className += " active-customer-question";
    }

    return className;
  };

  return (
    <div aria-live="polite" aria-atomic="true">
      <h3 className="text-xl font-semibold px-6 m-0">
        Frequently Asked Questions From Customers
      </h3>
      <div className="customer-qa-wrapper bg-white rounded-md overflow-hidden">
        {questionsAndAnswers.map((questionAndAnswer, index) => (
          <div
            id={`customer-qa${index}`}
            className={`customer-qa${getActiveClass(index)}`}
            key={questionAndAnswer.question}
            style={{ boxShadow: "inset 0 0 0 #fff" }}
          >
            <div
              suppressHydrationWarning
              className={`customer-question ${questionClasses()}`}
              role="button"
              onClick={() => handleClick(`customer-qa${index}`)}
              tabIndex={0}
              aria-expanded={isItemInActiveIdList(`customer-qa${index}`)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  handleClick(`customer-qa${index}`);
                }
              }}
            >
              <span
                dangerouslySetInnerHTML={{
                  __html: questionAndAnswer.question,
                }}
              />
            </div>
            <div
              suppressHydrationWarning
              className="csr-answer text-sm font-normal disabled cursor-default -mt-2 pt-0 pr-10 pb-[18px] pl-[18px]"
              dangerouslySetInnerHTML={{ __html: questionAndAnswer.answer }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ExpandedDescriptionQuestionsAndAnswers;
